import { PlatformLocation } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  submiting: boolean = false;
  form: FormGroup;
  mauticFormSrc: any = null;
  showPassword: boolean = true;

  constructor(
    private http: HttpService,
    private router: Router,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private pLocation: PlatformLocation,
    private sanitazer: DomSanitizer
  ) {

    this.form = fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    })

  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(
      params => {
        this.form.patchValue({ email: params.email });
      }
    )

    const subject = new Subject();
    subject.subscribe(
      ({ scope, trigger }: any) => {

        if (scope === 'auth:login')
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject);

  }

  submit() {

    if (!this.form.invalid) {
      const data = this.form.getRawValue();
      this.http.save('auth:login', data)
        .subscribe(
          (result: any) => {

            if (result.data) {
              localStorage.setItem('token', JSON.stringify(result.data));

              const token = localStorage.getItem('token');
              if (token) {
                const currentUser = JSON.parse(token);
                const email = currentUser?.email;
                const status = currentUser?.signature_status;

                if (email && status == 'TRIAL') {
              
                  const data = { email: email };

                  this.http.save('company:period', data)
                    .subscribe(
                      (result: any) => {
                        if (result.data) {
                          //console.log('periodo', result.data);
                          localStorage.setItem('token', JSON.stringify(result.data));
                          // window.location.reload();
                        } else {
                          console.error('erro no periodo');
                        }
                      },
                      err => console.error('Erro Temporizador Payment:', err)
                    );
                }
              
              }

              this.snackbar.open('Login feito com sucesso!', 'OK', { duration: 3000 });
              this.router.navigate(['/', 'customer']);
            } else {
              this.snackbar.open('Senha errada, tente novamente!', 'OK', { duration: 3000 });
              this.form.patchValue({ password: null });
            }

          },
          err => this.errorReport.showMessage(err)
        );
    }

  }

  recoveryPass() {

    const email = this.form.get('email').value;

    if (!email) {
      alert('Informe seu e-mail e tente novamente!')
      this.pLocation.back();
      return;
    }

    const params = new URLSearchParams();
    const uuid = uuidv4();
    const hBase = this.pLocation.getBaseHrefFromDOM();
    params.append('email', email);
    params.append('url', `http://${location.host}${hBase}/auth/reset-password/${uuid}?email=${email}`);
    params.append('token', uuid);

    this.mauticFormSrc = this.sanitazer
      .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/send-recovery?${params.toString()}`);
    this.snackbar.open(`Enviamos instruções de como recuperar senha para ${email}`, 'OK', { duration: 3000 });

  }

  goBack() {
    window.history.back();
  }

}
